module.exports = __webpack_public_path__ + "static/media/loading.b35992e4.png";